"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var constants_1 = require("@/constants");
exports.default = vue_1.default.extend({
    name: 'MoonGlobalParameterValue',
    props: {
        moonData: {
            type: Object,
        },
    },
    computed: {
        isMax: function () {
            return (this.moonData.colonyRate >= constants_1.MAXIMUM_COLONY_RATE &&
                this.moonData.miningRate >= constants_1.MAXIMUM_MINING_RATE &&
                this.moonData.logisticsRate >= constants_1.MAXIMUM_LOGISTICS_RATE);
        },
    },
});
